import Glass_module_default from "./Glass.module.js";
import classNames from "classnames";
import { Children, forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/Glass/Glass.tsx
/**
* Adds a border of glass around a child component.
*/
var Glass = forwardRef(({ children, className, ...rest }, ref) => /* @__PURE__ */ jsx("div", {
	ref,
	className: classNames(className, Glass_module_default.glass),
	...rest,
	children: Children.only(children)
}));
Glass.displayName = "Glass";
//#endregion
export { Glass };

//# sourceMappingURL=Glass.js.map